module.exports = __webpack_public_path__ + "static/media/Hund-min.6be7aef4.PNG";